import { render, staticRenderFns } from "./TransfersForm.vue?vue&type=template&id=2fb3f2bb&scoped=true"
import script from "./TransfersForm.vue?vue&type=script&lang=js"
export * from "./TransfersForm.vue?vue&type=script&lang=js"
import style0 from "./TransfersForm.vue?vue&type=style&index=0&id=2fb3f2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb3f2bb",
  null
  
)

export default component.exports